import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Button, Typography,
  CircularProgress, Box, Modal, Fade, Backdrop
} from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { FaCloudUploadAlt } from "react-icons/fa";

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxHeight: '80vh',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  border: '1px solid #ccc',
  boxShadow: 24,
  p: 4,
};

const DeviceStatus = () => {
  const [devices, setDevices] = useState([]);
  const [loadingStates, setLoadingStates] = useState({});
  const [logsReady, setLogsReady] = useState({});
  const [logsData, setLogsData] = useState([]);
  const [employeeMap, setEmployeeMap] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [currVersion, setCurrVersion] = useState("");
  

  // useEffect(() => {
  //   fetchStatuses();
  //   // fetchVersion();
  //   console.log(fetchVersion());

  //   const interval = setInterval(fetchStatuses, 3000); // Refresh every 3s
  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
  fetchStatuses();

  fetchVersion().then(setCurrVersion);

  const interval = setInterval(fetchStatuses, 3000);
  return () => clearInterval(interval);
}, []);

  const fetchStatuses = async () => {
    try {
      const res = await axios.get('https://gannondunkerley.in/devicelogs/devices/status');
      const deviceList = res.data;

      // Show alert when sync finishes with a message
      deviceList.forEach(device => {
        if (device.syncResult?.message && device.syncResult.message !== "🔄 Sync in progress...") {
          alert(`Device ${device.deviceId}: ${device.syncResult.message}`);
        }
      });

      setDevices(deviceList);
    } catch (err) {
      console.error("Failed to fetch device statuses", err);
    }
  };

const fetchVersion = async () => {
  try {
    const res = await axios.get('https://gannondunkerley.in/version/check');
    return res.data.py_app;
  } catch (err) {
    console.error("Failed to fetch device version", err);
  }
};



  const handleForceSync = async (deviceId) => {
    try {
      const res = await axios.post('https://gannondunkerley.in/devicelogs/device/trigger', { deviceId });
      alert(res.data.message || 'Triggered successfully');
    } catch (err) {
      console.error("Trigger error", err);
      alert("Failed to trigger sync");
    }
  };

  const handleSendLogsCommand = async (deviceId) => {
    setLoadingStates(prev => ({ ...prev, [deviceId]: true }));
    try {
      await axios.post('https://gannondunkerley.in/devicelogs/send-command', {
        deviceId,
        type: 'showLogs'
      });

      let attempts = 0;
      let logs = [];

      while (attempts < 5) {
        const res = await axios.get(`https://gannondunkerley.in/devicelogs/view-local/${deviceId}`);
        logs = res.data.logs || [];

        if (logs.length > 0) break;
        await new Promise(res => setTimeout(res, 3000));
        attempts++;
      }

      if (logs.length > 0) {
        setLogsReady(prev => ({ ...prev, [deviceId]: true }));
      } else {
        alert("❌ Device didn't upload logs in time.");
      }
    } catch (err) {
      alert("❌ Failed to send command.");
    } finally {
      setLoadingStates(prev => ({ ...prev, [deviceId]: false }));
    }
  };

  const handleViewLogs = async (deviceId) => {
    try {
      const [logRes, empRes] = await Promise.all([
        axios.get(`https://gannondunkerley.in/devicelogs/view-local/${deviceId}`),
        axios.get('https://gannondunkerley.in/employees')
      ]);

      const logs = logRes.data.logs || [];
      const empMap = {};

      for (const emp of empRes.data.EmployeeList) {
        if (emp.empCode) {
          empMap[emp.empCode] = emp.name || 'Unknown';
        }
      }

      setEmployeeMap(empMap);
      setLogsData(logs);
      setOpenModal(true);
    } catch (err) {
      console.error("❌ Failed to load logs or employee data.", err);
      alert("❌ Failed to load logs.");
    }
  };

  return (
    <Box className="content" sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        📡 Device Status
      </Typography>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Device ID</strong></TableCell>
              <TableCell><strong>Electron Version</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell><strong>Last Seen</strong></TableCell>
              <TableCell><strong>Trigger</strong></TableCell>
              {/* <TableCell><strong>Sync Result</strong></TableCell> */}
              <TableCell><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {devices.map((device) => (
              <TableRow key={device.deviceId}>
                <TableCell>{device.deviceId}</TableCell>

                <TableCell sx={{ color: device.version === currVersion ? 'green' : 'red' }}>
                  {device.version}
                </TableCell>

                <TableCell sx={{ color: device.status === "Online" ? 'green' : 'red' }}>
                  {device.status}
                </TableCell>

                <TableCell>
                  {new Date(device.lastSeen).toLocaleString()}
                </TableCell>

                <TableCell>{String(device.trigger)}</TableCell>
                {/* <TableCell>
                  {device.syncResult?.message ? (
                    <span style={{
                      color: device.syncResult.noPastLogs ? 'orange' : 'green',
                      fontWeight: 'bold'
                    }}>
                      {device.syncResult.message}
                    </span>
                  ) : (
                    <span style={{ color: 'gray' }}>No result</span>
                  )}
                </TableCell> */}

                <TableCell>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<SyncIcon />}
                    sx={{ mr: 1 }}
                    onClick={() => handleForceSync(device.deviceId)}
                    disabled={device.trigger === "True"}
                  >
                    Force Sync
                  </Button>


                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    startIcon={
                      loadingStates[device.deviceId] ? <CircularProgress size={16} /> : <FaCloudUploadAlt />
                    }
                    sx={{ mr: 1 }}
                    onClick={() => handleSendLogsCommand(device.deviceId)}
                    disabled={loadingStates[device.deviceId] || device.status !== "Online"}
                  >
                    {loadingStates[device.deviceId] ? 'Sending...' : 'Fetch Logs'}
                  </Button>

                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<VisibilityIcon />}
                    color="secondary"
                    onClick={() => handleViewLogs(device.deviceId)}
                    disabled={!logsReady[device.deviceId]}
                  >
                    View Logs
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={openModal}>
          <Box sx={modalStyle}>
            <Typography variant="h6" gutterBottom>📄 Local Attendance Logs</Typography>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Emp Code</strong></TableCell>
                    <TableCell><strong>Name</strong></TableCell>
                    <TableCell><strong>Status</strong></TableCell>
                    <TableCell><strong>Timestamp</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {logsData.map((log, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{log.empCode}</TableCell>
                      <TableCell>{employeeMap[log.empCode] || 'Unknown'}</TableCell>
                      <TableCell>{log.status}</TableCell>
                      <TableCell>{log.timestamp}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
};

export default DeviceStatus;
